function checkFormCompletion() {
    const form = document.querySelector('.order-section__card__form');
    const addressBlock = document.querySelector('.modal__content_new-address__form__input-address');
    
    if (!form || !addressBlock) {
        console.log('❌ Форма или блок адреса не найдены');
        return;
    }
    
    const inputs = form.querySelectorAll('input[type="text"]');
    let allFieldsFilled = true;
    
    inputs.forEach(input => {
        if (!input.value || input.value.trim() === '') {
            allFieldsFilled = false;
        }
    });
    
    
    if (allFieldsFilled) {
        addressBlock.style.display = 'grid';
        // console.log('🎯 Блок адреса показан (display: grid)');
    } else {
        addressBlock.style.display = 'none';
        // console.log('🎯 Блок адреса скрыт');
    }
}

// Функция для инициализации обработчиков событий
function initFormValidationTrigger() {
    const form = document.querySelector('.order-section__card__form');
    
    if (!form) {
        console.log('❌ Форма order-section__card__form не найдена');
        return;
    }
    
    // Получаем все input поля в форме
    const inputs = form.querySelectorAll('input[type="text"]');
    
    // Добавляем обработчики событий для каждого поля
    inputs.forEach(input => {
        input.addEventListener('input', checkFormCompletion);
        input.addEventListener('change', checkFormCompletion);
        input.addEventListener('blur', checkFormCompletion);
    });
    
    // Проверяем состояние формы при загрузке
    checkFormCompletion();
    
    console.log('✅ Обработчики проверки формы инициализированы');
}

// Функция для принудительной проверки формы (для внешнего вызова)
function forceCheckFormCompletion() {
    checkFormCompletion();
}

// Экспортируем функции
export {
    checkFormCompletion,
    initFormValidationTrigger,
    forceCheckFormCompletion
};

// Экспортируем в глобальную область для использования в других модулях
window.checkFormCompletion = checkFormCompletion;
window.initFormValidationTrigger = initFormValidationTrigger;
window.forceCheckFormCompletion = forceCheckFormCompletion;

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
    // Ждем немного, чтобы все элементы загрузились
    setTimeout(() => {
        initFormValidationTrigger();
    }, 100);
}); 